var map = {
	"./about-left-shape.png": "abb7",
	"./about-left-shape.svg": "511a",
	"./about-right-shape.png": "a4b1",
	"./about-right-shape.svg": "beac",
	"./cta-bg.png": "0663",
	"./favicon.png": "a017",
	"./favicon.svg": "69b8",
	"./footer/footer-bg.svg": "d0c4",
	"./header-bg.svg": "4c56",
	"./hero/header-bg.svg": "3951",
	"./hero/header2.svg": "2110",
	"./hero/softinya-teaser.png": "9e67",
	"./icon-card-1.webp": "c83e",
	"./icon-card-2.webp": "676f",
	"./icon-card-3.webp": "d0be",
	"./icon-card-4.webp": "e317",
	"./icon-video.png": "fa54",
	"./languages/az.png": "e3c9",
	"./languages/en.png": "9a14",
	"./languages/tr.png": "ccb4",
	"./logo/logo-2.svg": "590b",
	"./logo/logo.svg": "7ce8",
	"./softinya-1.png": "14f5",
	"./softinya-10.png": "f5d2",
	"./softinya-2.png": "152d",
	"./softinya-3.png": "a8cd",
	"./softinya-4.png": "4b7f",
	"./softinya-5.png": "da8d",
	"./softinya-6.png": "c362",
	"./softinya-7.png": "1e20",
	"./softinya-8.png": "5856",
	"./softinya-9-lang.png": "c93e",
	"./softinya-9.png": "4451",
	"./softinya-prop-1.webp": "6db5",
	"./softinya-prop-2.webp": "f88f",
	"./softinya-prop-3.webp": "164e",
	"./softinya-prop-4.webp": "62ef",
	"./softinya-prop-5.png": "fec1",
	"./softinya-prop-6.webp": "d728",
	"./softinya-prop-7.webp": "0e3b",
	"./softinyalms-az.mp4": "4344",
	"./softinyalms-de.mp4": "d766",
	"./softinyalms-en.mp4": "674b",
	"./softinyalms-tr.mp4": "4de3",
	"./switch-softinya.png": "9ebb",
	"./unlike.png": "c442",
	"./woman-holding-softinya-logo.png": "d6f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d25b";